import { runQueryCommand, RIASTABLE, runGetCommand, getCounter, updateDB } from "./dynamoDB";
import { getServerEnv } from "./server";

export const getUserRecord = async (
	userId: number,
	sk: string
) => {
	"use server";
	
	const r = await runGetCommand({
		TableName: RIASTABLE,
		 Key: { pk: `USER#${userId}`, sk },
	} );

	return {...r.Item };
};

export const getUserByEmail = async (email: string) => {
	"use server";

	const r = await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiUserByEmail",
		KeyConditionExpression: "email = :email",
		ExpressionAttributeValues: {
			":email": email,
		},
		ScanIndexForward: false,
	} );
	
	return r?.items?.length ? r.items[0] : null;
};

export const saveRegistration = async data => {
	"use server";

	const existingUser = await getUserByEmail( data.email );

	if (existingUser) {
		return { success: false, err: "User already exists", add: existingUser };
	}

	const userId = await getCounter("USER");
	if (userId < 1) {
		return { success: false, err: "Error generating userId", add: userId };
	}

	const pk = `USER#${userId}`;
	const sk = `USER#${Date.now() / 1000}`;

	const updates = {
		userId: userId,
		registered: Date.now().toString(),
		recordType: "USER",
		firstName: data.firstName,
		lastName: data.lastName,
		name: `${data.firstName} ${data.lastName}`,
		email: data.email,
		lastLogin: Date.now().toString(),
		memberships: {
			arb: data.ARB,
			cibse: data.CIBSE,
			rias: data.RIAS,
			ciat: data.MCIAT,
			constructionProfessional: data.contructionPro
		},
		address: {
			title: data.companyName,
			city: data.city,
			county: data.region,
			addr1: data.addr1,
			postcode: data.postcode,
		},
		targetScheme: data.targetScheme,
		roles: {
			"cpd": data.targetScheme == "CPD" ? "applying" : null,
			"certifier": data.targetScheme != "CPD" ? "applying" : null,
		}
	};

	try {
		const r = await updateDB(pk, sk, updates);
		return { success: true, entry: r };
	} catch (err) {
		console.log("err", err);
	}

	return { success: false, err: "unknown" };
};

export const getPlotCounts = async (description: string) => {
	"use server";

	if (description.trim() == "") return { success: false };

	const { OpenAI } = await import("openai");

	const openai = new OpenAI({ apiKey: getServerEnv().openAPIKey });

	const prompt = `Extract the precise count of domestic and non-domestic buildings mentioned in the text. Return a strict JSON object in the form:
{ "domestic": <number>, "non_domestic": <number>, "groups": [ { "type": "terraced", "count": <number>, "type": "flats", "count": <number>, "type": "detached", "count": <number> }, ... ] }

Text: """${description}"""`;

	const response = await openai.chat.completions.create({
		model: "gpt-4o-mini",
		temperature: 0,
		messages: [{ role: "user", content: prompt }],
		response_format: { type: "json_object" },
	});

	return JSON.parse(response.choices[0].message.content);
};
